/** @format */
import { ModelPriceModifierGroup } from '@toucan/client/global/model';

import {
    Filter,
    FilterOption,
} from '@toucan/client/features/search/config/types';

export function getFilterOption(
    modifierGroupId: ModelPriceModifierGroup['modifiers'][0]['id'],
    filter: Filter
) {
    return filter.options.find(
        (option) => Number(option.value) === modifierGroupId
    );
}

export function areAllAccessoryOptionsCountEqualToInitalResultCount(
    modifierGroups: ModelPriceModifierGroup[] = [],
    filter: Filter,
    totalInitialResults: number
) {
    const modifierOptions = modifierGroups?.flatMap(
        ({ modifiers }) => modifiers
    );

    return modifierOptions?.every((modifier) => {
        const option = getFilterOption(modifier.id, filter);
        if (!option) return true;
        return option.quantity === totalInitialResults;
    });
}

export function getSelectedOptionsByModifierGroupType(
    essential: ModelPriceModifierGroup[],
    extra: ModelPriceModifierGroup[],
    selectedOptions: Filter['selectedOptions']
) {
    const selectedEssentialOptions: FilterOption[] = [];
    const selectedExtraOptions: FilterOption[] = [];

    if (!essential || !extra) {
        return { selectedEssentialOptions, selectedExtraOptions };
    }

    const essentialModifierIds =
        essential?.flatMap((group) => group.modifiers.map(({ id }) => id)) ??
        [];

    const extraModifierIds =
        extra?.flatMap((group) => group.modifiers.map(({ id }) => id)) ?? [];

    return selectedOptions.reduce(
        (options, option) => {
            const optionId = Number(option.value);

            if (essentialModifierIds.includes(optionId)) {
                options.selectedEssentialOptions.push(option);
                return options;
            }

            if (extraModifierIds.includes(optionId)) {
                options.selectedExtraOptions.push(option);
                return options;
            }

            return options;
        },
        { selectedEssentialOptions, selectedExtraOptions }
    );
}
